import React, { useEffect, useState } from 'react';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { Link, useParams } from 'react-router-dom';
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL } from '../Dashboard/api/Api';
import { server } from '../../server';
import Axios from '../../axios/Axios';

const Mmlite = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const type = lStorage.user.isAdmin;
    const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children
    const { id, userType } = useParams();

    const [email, setEmail] = useState('');
    const [error, setError] = useState({
        errorStatus: false,
        bgColor: '',
        errorMessage: ''
    });
    const [mmlite, setMmlite] = useState(false)

    useEffect(() => {
        getUserDetails();
    }, []);

    const getUserDetails = async () => {
        try {
            const response = await fetch(`${HOST_URL}/admin_user_list.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: userId,
                    method: "retrieve",
                    type: "userdetails",
                    ret_user_id: id,
                    token: userToken,
                }),
            });

            const result = await response.json();

            if (result.success) {
                setEmail(result.data[0].email);
                setMmlite(result.data[0].mmlite);
            } else {
                setError({
                    errorStatus: true,
                    bgColor: "alert alert-danger alert-dismissible",
                    errorMessage: result.message,
                });
            }
        } catch (error) {
            setError({
                errorStatus: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: "Something went wrong. Please try again later.",
            });
        }
    };


    const Submit = async () => {
        try {
            let paramData = {
                user_id: userId,
                token: userToken,
                method: "enable_mmlite",
                ret_user_id: id,
                mmlite: mmlite ? 1 : 0,
            }
            let { data } = await Axios.post(`${server}/api/admin_user_list.php`, paramData)
            if (data.success) {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-success alert-dismissible',
                    errorMessage: data.message
                });
            }
            else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger alert-dismissible',
                    errorMessage: data.message
                });
            }
        } catch (error) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger alert-dismissible',
                errorMessage: error.message
            });
        }

    }

    return (
        <div>
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3>API Auto Short URL <strong className='text-info'>{email}</strong></h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title mb-0">
                                            <nav className="text-center" aria-label="breadcrumb">
                                                <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                    <Link to={`/admin/user-details/${id}/${userType}`}><li className="breadcrumb-item">User Details</li></Link>
                                                   {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.transactiondetails)) && <Link to={`/admin/user-transaction-details/${id}/${userType}`}><li className="breadcrumb-item">Transaction Details</li></Link>}
                                                    {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.addeditprice)) &&<Link to={`/admin/user-price-details/${id}/${userType}?channel=whatsapp`}><li className="breadcrumb-item">Add Price</li></Link>}
                                                     {(type === "admin" || (type === "subadmin" && permissionsubadmin.awssettings)) && ( <Link to={`/admin/aws-settings/${id}/${userType}?channel=whatsapp`}><li className="breadcrumb-item">AWS Settings</li></Link>
                                                        )}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.billingmode)) && (
                                                        <Link to={`/admin/user-billing-mode/${id}/${userType}`} >
                                                            {" "} <li className="breadcrumb-item">{" "} Billing Mode{" "} </li>
                                                        </Link>
                                                    )}
                                                    {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.addeditcredit)) && <Link to={`/admin/user-add-price/${id}/${userType}`}><li className="breadcrumb-item">Add Credit</li></Link>}
                                                           { (type === "admin" || (type === "subadmin" && permissionsubadmin.entitybypass)) &&<Link to={`/admin/user-entity-pass/${id}/${userType}`}><li className="breadcrumb-item">Entity By Pass</li></Link>}
                                                            {(type === "admin" || (type === "subadmin" && permissionsubadmin.changecurrency)) &&<Link to={`/admin/change-currency/${id}/${userType}`}><li className="breadcrumb-item">Change Currency</li></Link>}
                                                            {(type === "admin" || (type === "subadmin" && permissionsubadmin.bulksmsroutesetting)) &&<Link to={`/admin/bulk-sms-route/${id}/${userType}`}><li className="breadcrumb-item">Bulk Sms Route Setting</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.autoshorturl)) &&
                                                        <Link
                                                            to={`/admin/api-auto-short-url/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                Auto Short URL
                                                            </li>
                                                        </Link>}
                                                    {/* {type === "admin" &&
                                                        <Link
                                                            to={`/admin/extra-settings/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                Extra Settings
                                                            </li>
                                                        </Link>} */}
                                                         {(type === "admin" || (type === "subadmin" && permissionsubadmin.extrasettings)) &&
                                                        <Link
                                                            to={`/admin/extra-settings/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                Extra Settings
                                                            </li>
                                                        </Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.mmlite)) &&
                                                        <Link
                                                            to={`/admin/mmlite/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item active">
                                                                MMLite
                                                            </li>
                                                        </Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.ai_bot)) &&
                                                        <Link
                                                            to={`/admin/ai-bot/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                AI Bot
                                                            </li>
                                                        </Link>}
                                                     {(type === "admin" || (type === "subadmin" && permissionsubadmin.edituserplan)) &&
                                                        <Link
                                                            to={`/admin/edit-user-plan/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                Edit User Plan
                                                            </li>
                                                        </Link>}
                                                         {/* {type === "admin" &&
                                                        <Link
                                                            to={`/admin/ivr-setting/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                IVR Setting
                                                            </li>
                                                        </Link>} */}

                                                </ol>
                                            </nav>
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {error.errorStatus && (
                                            <div className={error.bgColor} role="alert">
                                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <div>{error.errorMessage}</div>
                                            </div>
                                        )}
                                        <div className="filter-option">
                                            <div className="row mt-3">
                                                <div className='col-12'>
                                                    <div className='row mt-3'>
                                                        <div className='col-6'>
                                                            <input
                                                                type="checkbox"
                                                                checked={mmlite}
                                                                onChange={() => setMmlite(!mmlite)}
                                                            />
                                                            <span className="ml-2"><b>MMLite</b></span>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <button type="button" style={{ float: "right" }} onClick={Submit} className="btn btn-primary mt-3">Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <AdminFooter />
                </div>
            </div>
        </div>
    );
};

export default Mmlite;